<template>
  <input
    ref="name"
    :value="value"
    class="field-input__inner form__input"
    :placeholder="placeholder"
    :required="required"
    type="text"
    @keydown="inputOnlyLatin"
    @input="onInput"
    @blur="$emit('blur')"
  >
</template>
<script>
export default {
  name: 'InputNameLatin',
  props: {
    placeholder: {
      type: String,
      default: 'ФИО*',
    },
    value: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      name: '',
    };
  },
  methods: {
    inputOnlyLatin(e) {
      const regExp = /^[a-z ,.'-]+$/i;
      if (!regExp.test(e.key)) {
        e.preventDefault();
      }
    },
    onInput($event) {
      this.$emit('input', $event.target.value);
    },
  },
};
</script>
